import type { Contract } from "@store/slices/contract";

export const contractSelector = (state): Contract => state.contract;
export const contractNodeManagerSelector = (state): number =>
	state.contract.nodeManagerVersion;
export const contractMigrationRequired = (state): boolean =>
	state.contract.nodeManagerVersion === 4;
export const contractNodeList = (state): any => state.contract.nodeList;
